import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import ImageCropper from "Components/UI/Image/ImageCropper";
const activestatus = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const CompanyInfo = ({ descriptions }) => {
  const isNumberKey = (evt) => {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  };
  const {
    register,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="mb-5">
      {/* <h5 className="table-title mb-3">Company Settings</h5> */}

      <div className="form-row row">
        <div className="col-md-4 mb-3">
          <Input
            name="companyName"
            type="text"
            placeholder="Company Name"
            className={`form-control ${errors.companyName ? "is-invalid" : ""}`}
            label="Company Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Fullname is required"
            maxLength={100}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            name="companyUEN"
            type="text"
            placeholder="Company UEN"
            className={`form-control ${errors.companyUEN ? "is-invalid" : ""}`}
            label="Company UEN"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company UEN is required"
            maxLength={100}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].uniqueIDPrefix"
            type="text"
            placeholder="Unique ID Prefix"
            className={`form-control ${
              errors?.companySettings?.[0]?.uniqueIDPrefix ? "is-invalid" : ""
            }`}
            label="Unique ID Prefix"
            labelClassName="form-label"
            required={true}
            requiredMessage="Unique ID Prefix is required"
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].nextUniqueId"
            type="text"
            placeholder="Next Unique Id"
            className={`form-control ${
              errors?.companySettings?.[0]?.nextUniqueId ? "is-invalid" : ""
            }`}
            label="Next Unique Id"
            labelClassName="form-label"
            required={true}
            requiredMessage="Next Unique Id is required"
            onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="address1"
            type="text"
            placeholder="Address 1"
            className={`form-control ${errors.address1 ? "is-invalid" : ""}`}
            label="Address 1"
            labelClassName="form-label"
            required={true}
            requiredMessage="Address 1 is required"
            maxLength={200}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="address2"
            type="text"
            placeholder="Address 2"
            className={`form-control ${errors.address2 ? "is-invalid" : ""}`}
            label="Address 2"
            labelClassName="form-label"
            required={false}
            requiredMessage="Address 1 is required"
            maxLength={200}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="address3"
            type="text"
            placeholder="Address 3"
            className={`form-control ${errors.address3 ? "is-invalid" : ""}`}
            label="Address 3"
            labelClassName="form-label"
            required={false}
            requiredMessage="Address 1 is required"
            maxLength={200}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="country"
            type="text"
            placeholder="Country"
            className={`form-control ${errors.country ? "is-invalid" : ""}`}
            label="Country"
            labelClassName="form-label"
            required={true}
            requiredMessage="Country is required"
            maxLength={50}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="zipCode"
            type="text"
            placeholder="Postal Code"
            className={`form-control ${errors.zipCode ? "is-invalid" : ""}`}
            label="Postal Code"
            labelClassName="form-label"
            required={true}
            requiredMessage="postal Code is required"
            maxLength={10}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="email"
            type="email"
            placeholder="Email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            label="Email"
            labelClassName="form-label"
            required={true}
            requiredMessage="Email is required"
            // maxLength={10}
          />
        </div>

        <div className="col-md-4 mb-3">
          <div className="pass-group form-floating">
            <input
              type="tel"
              {...register("phoneNo", {
                required: "Please enter phone number",
                pattern: {
                  value: /^[0-9]{8}$/,
                  message: "Phone number must be exactly 8 digits",
                },
              })}
              placeholder="Enter phone number"
              className={`form-control ${errors?.phoneNo ? "is-invalid" : ""}`}
              inputMode="numeric"
              maxLength={8}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 8);
              }}
            />
            {/* <span
              // onClick={() => setShowPassword((prev) => !prev)}
              className={`fas toggle-password ${
                showPassword ? "fa-eye" : "fa-eye-slash"
              }`}
            /> */}
            <label className="form-label">Phone Number <span className="astrik">*</span></label>
            <div className="invalid-feedback">{errors?.phoneNo?.message}</div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companyStartYear"
            type="date"
            placeholder="Company Start Year"
            className={`form-control ${
              errors.companyStartYear ? "is-invalid" : ""
            }`}
            label="Company Start Year"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company Start Year is required"
            onChange={(date, dateString) => {
              setValue("companyStartYear", dateString);
              trigger("companyStartYear");
            }}
            picker="year"
            dateFormat="YYYY"
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companyRegNo"
            type="text"
            placeholder="Company Reg No"
            className={`form-control ${
              errors.companyRegNo ? "is-invalid" : ""
            }`}
            label="Company Reg No"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company Reg No is required"
            maxLength={10}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            name="taxRegNo"
            type="text"
            placeholder="Tax Reg No"
            className={`form-control ${errors.taxRegNo ? "is-invalid" : ""}`}
            label="Tax Reg No"
            labelClassName="form-label"
            required={true}
            requiredMessage="Tax Reg No is required"
            maxLength={10}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].haveCpfeSubmission`}
            type="commonSelect"
            placeholder="Have Cpf eSubmission"
            className={`form-control ${
              errors?.companySettings?.[0]?.haveCpfeSubmission
                ? "is-invalid"
                : ""
            }`}
            label="Have Cpf eSubmission"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Have Cpf eSubmission is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].haveCpfeSubmission", selectedOption);
              trigger("companySettings[0].haveCpfeSubmission");
            }}
            defaultValue={watch("companySettings[0].haveCpfeSubmission")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].csn"
            type="text"
            placeholder="CSN"
            className={`form-control ${
              errors?.companySettings?.[0]?.csn ? "is-invalid" : ""
            }`}
            label="CSN"
            labelClassName="form-label"
            required={true}
            requiredMessage="CSN is required"
            maxLength={12}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].irastaxRefNo"
            type="text"
            placeholder="IRAS Tax RefNo"
            className={`form-control ${
              errors?.companySettings?.[0]?.irastaxRefNo ? "is-invalid" : ""
            }`}
            label="IRAS Tax RefNo"
            labelClassName="form-label"
            required={true}
            requiredMessage="IRAS Tax RefNo is required"
            maxLength={10}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].payDayOfMonth"
            type="number"
            placeholder="Pay Day Of Month"
            className={`form-control ${
              errors?.companySettings?.[0]?.payDayOfMonth ? "is-invalid" : ""
            }`}
            label="Pay Day Of Month"
            labelClassName="form-label"
            required={true}
            requiredMessage="Pay Day Of Month is required"
            maxLength={5}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].alternatePayDayOfMonth"
            type="number"
            placeholder="Alternate Pay Day Of Month"
            className={`form-control ${
              errors?.companySettings?.[0]?.alternatePayDayOfMonth
                ? "is-invalid"
                : ""
            }`}
            label="Alternate Pay Day Of Month"
            labelClassName="form-label"
            required={false}
            requiredMessage="Alternate Pay Day Of Month is required"
            maxLength={2}
          />
        </div>

        {/* <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].breakTime"
            type="text"
            placeholder="Break Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.breakTime ? "is-invalid" : ""
            }`}
            label="Break Time (Mins)"
            labelClassName="form-label"
            required={true}
            requiredMessage="Break Time is required"
          />
        </div> */}

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].noOfWorkingDaysPerWeek"
            type="text"
            placeholder="No Of Working Days Per Week"
            className={`form-control ${
              errors?.companySettings?.[0]?.noOfWorkingDaysPerWeek
                ? "is-invalid"
                : ""
            }`}
            label="No Of Working Days Per Week"
            labelClassName="form-label"
            required={true}
            requiredMessage="No Of Working Days Per Week is required"
            maxLength={9}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].defaultBankCode"
            type="text"
            placeholder="Default Bank Code"
            className={`form-control ${
              errors?.companySettings?.[0]?.defaultBankCode ? "is-invalid" : ""
            }`}
            label="Default Bank Code"
            labelClassName="form-label"
            required={true}
            requiredMessage="Default Bank Code is required"
            maxLength={10}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].haveOnlinePayslip"
            type="commonSelect"
            placeholder="Have Online Payslip"
            className={`form-control ${
              errors?.companySettings?.[0]?.haveOnlinePayslip
                ? "is-invalid"
                : ""
            }`}
            label="Have Online Payslip"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Have Online Payslip is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].haveOnlinePayslip", selectedOption);
              trigger("companySettings[0].haveOnlinePayslip");
            }}
            defaultValue={watch("companySettings[0].haveOnlinePayslip")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].cpfsalaryLimit"
            type="text"
            placeholder="CPF Salary Limit"
            className={`form-control ${
              errors?.companySettings?.[0]?.cpfsalaryLimit ? "is-invalid" : ""
            }`}
            label="CPF Salary Limit"
            labelClassName="form-label"
            required={true}
            requiredMessage="CPF Salary Limit is required"
            maxLength={9}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].isActive"
            type="commonSelect"
            placeholder="Status"
            className={`form-control ${
              errors?.companySettings?.[0]?.isActive ? "is-invalid" : ""
            }`}
            label="Status"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].isActive", selectedOption);
              trigger("companySettings[0].isActive");
            }}
            defaultValue={watch("companySettings[0].isActive")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].sdlpercentage"
            type="text"
            placeholder="SDL Percentage"
            className={`form-control ${
              errors?.companySettings?.[0]?.sdlpercentage ? "is-invalid" : ""
            }`}
            label="SDL Percentage"
            labelClassName="form-label"
            required={true}
            requiredMessage="SDL Percentage is required"
            maxLength={9}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].sdlminAmount"
            type="text"
            placeholder="SDL Min Amount"
            className={`form-control ${
              errors?.companySettings?.[0]?.sdlminAmount ? "is-invalid" : ""
            }`}
            label="SDL Min Amount"
            labelClassName="form-label"
            required={true}
            requiredMessage="SDL Min Amount is required"
            maxLength={9}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].sdlmaxAmount"
            type="text"
            placeholder="SDL Max Amount"
            className={`form-control ${
              errors?.companySettings?.[0]?.sdlmaxAmount ? "is-invalid" : ""
            }`}
            label="SDL Max Amount"
            labelClassName="form-label"
            required={true}
            requiredMessage="SDL Max Amount is required"
            maxLength={9}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].cpfminSalaryLimit"
            type="text"
            placeholder="CPF Min Salary Limit"
            className={`form-control ${
              errors?.companySettings?.[0]?.cpfminSalaryLimit
                ? "is-invalid"
                : ""
            }`}
            label="CPF Min Salary Limit"
            labelClassName="form-label"
            required={true}
            requiredMessage="CPF Min Salary Limit is required"
            maxLength={9}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].workingHoursPerWeek"
            type="text"
            placeholder="Working Hours Per Week"
            className={`form-control ${
              errors?.companySettings?.[0]?.workingHoursPerWeek
                ? "is-invalid"
                : ""
            }`}
            label="Working Hours Per Week"
            labelClassName="form-label"
            required={true}
            requiredMessage="Working Hours Per Week is required"
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].otDayPay_NoOfTime"
            type="text"
            placeholder="Ot Day Pay No Of Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.otDayPay_NoOfTime
                ? "is-invalid"
                : ""
            }`}
            label="Ot Day Pay No Of Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Ot Day Pay No Of Time is required"
            info={
              descriptions?.find((item) =>
                item?.description?.includes("OT Day Pay No of Time"),
              )?.description || ""
            }
          />
        </div>

        {/* <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].otHourly_NoOfTime"
            type="text"
            placeholder="Ot Hourly No Of Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.otHourly_NoOfTime
                ? "is-invalid"
                : ""
            }`}
            label="Ot Hourly No Of Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Ot Hourly No Of Time is required"
            onChange={isNumberKey}
            pattern="[0-9]*"
          />
        </div> */}

        {/* <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].otHourly_NoOfTime"
            type="text"
            placeholder="Ot Hourly No Of Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.otHourly_NoOfTime
                ? "is-invalid"
                : ""
            }`}
            label="Ot Hourly No Of Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Ot Hourly No Of Time is required"
            onChange={isNumberKey}
          />
        </div> */}

        {/* <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].oT1PayRate"
            type="text"
            placeholder="OT1 Pay Rate"
            className={`form-control ${
              errors?.companySettings?.[0]?.oT1PayRate ? "is-invalid" : ""
            }`}
            label="OT1 Pay Rate"
            labelClassName="form-label"
            required={true}
            requiredMessage="OT1 Pay Rate is required"
            onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].oT2PayRate"
            type="text"
            placeholder="OT2 Pay Rate"
            className={`form-control ${
              errors?.companySettings?.[0]?.oT2PayRate ? "is-invalid" : ""
            }`}
            label="OT2 Pay Rate"
            labelClassName="form-label"
            required={true}
            requiredMessage="OT2 Pay Rate is required"
            onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].extraHoursRate"
            type="text"
            placeholder="Extra Hours Rate"
            className={`form-control ${
              errors?.companySettings?.[0]?.extraHoursRate ? "is-invalid" : ""
            }`}
            label="Extra Hours Rate"
            labelClassName="form-label"
            required={true}
            requiredMessage="Extra Hours Rate is required"
            onChange={isNumberKey}
          />
        </div> */}

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].companyOpenTime"
            type="time"
            placeholder="Company Open Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.companyOpenTime ? "is-invalid" : ""
            }`}
            label="Company Open Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company Open Time is required"
            // onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].companyCloseTime"
            type="time"
            placeholder="Company Close Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.companyCloseTime ? "is-invalid" : ""
            }`}
            label="Company Close Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company Close Time is required"
            // onChange={isNumberKey}
          />
        </div>

        {/* <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].midNightStartTime"
            type="time"
            placeholder="Mid Night Start Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.midNightStartTime
                ? "is-invalid"
                : ""
            }`}
            label="Mid Night Start Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Mid Night Start Time is required"
            // onChange={isNumberKey}
          />
        </div> */}

        {/* <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].midNightEndTime"
            type="time"
            placeholder="Mid Night End Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.midNightEndTime ? "is-invalid" : ""
            }`}
            label="Mid Night End Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Mid Night End Time is required"
            // onChange={isNumberKey}
          />
        </div> */}

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].loginGraceTime"
            type="time"
            placeholder="Login Grace Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.loginGraceTime ? "is-invalid" : ""
            }`}
            label="Login Grace Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="Login Grace Time is required"
            // onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].foodAllowanceRate"
            type="text"
            placeholder="Food Allowance Rate"
            className={`form-control ${
              errors?.companySettings?.[0]?.foodAllowanceRate
                ? "is-invalid"
                : ""
            }`}
            label="Food Allowance Rate"
            labelClassName="form-label"
            required={true}
            requiredMessage="Food Allowance Rate is required"
            // onChange={isNumberKey}
            info={
              descriptions?.find((item) =>
                item?.description?.includes("Food Allowance Rate"),
              )?.description || ""
            }
            maxLength={9}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].otFoodAllowanceRate"
            type="text"
            placeholder="OT Food Allowance Rate"
            className={`form-control ${
              errors?.companySettings?.[0]?.otFoodAllowanceRate
                ? "is-invalid"
                : ""
            }`}
            label="OT Food Allowance Rate"
            labelClassName="form-label"
            required={true}
            requiredMessage="OT Food Allowance Rate is required"
            info={
              descriptions?.find((item) =>
                item?.description?.includes("OT Food Allowance Rate"),
              )?.description || ""
            }
            maxLength={9}
            // onChange={isNumberKey}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].otFoodAllowanceTime"
            type="time"
            placeholder="OT Food Allowance Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.otFoodAllowanceTime
                ? "is-invalid"
                : ""
            }`}
            label="OT Food Allowance Time"
            labelClassName="form-label"
            required={true}
            requiredMessage="OT Food Allowance Time is required"
            info={
              descriptions?.find((item) =>
                item?.description?.includes("OT Food Allowance Time"),
              )?.description || ""
            }
            // onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].companyLatitude"
            type="text"
            placeholder="Company Latitude"
            className={`form-control ${
              errors?.companySettings?.[0]?.companyLatitude ? "is-invalid" : ""
            }`}
            label="Company Latitude"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company Latitude is required"
            maxLength={10}
            // onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].companyLongitude"
            type="text"
            placeholder="Company Longitude"
            className={`form-control ${
              errors?.companySettings?.[0]?.companyLongitude ? "is-invalid" : ""
            }`}
            label="Company Longitude"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company Longitude is required"
            maxLength={10}
            // onChange={isNumberKey}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].haveMobileBreak`}
            type="commonSelect"
            placeholder="Have Mobile Break"
            className={`form-control ${
              errors?.companySettings?.[0]?.haveMobileBreak ? "is-invalid" : ""
            }`}
            label="Have Mobile Break"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Have Mobile Break is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].haveMobileBreak", selectedOption);
              trigger("companySettings[0].haveMobileBreak");
            }}
            defaultValue={watch("companySettings[0].haveMobileBreak")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].adjustWTROT`}
            type="commonSelect"
            placeholder="Adjust WTROT"
            className={`form-control ${
              errors?.companySettings?.[0]?.adjustWTROT ? "is-invalid" : ""
            }`}
            label="Adjust WTROT"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Adjust WTROT is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].adjustWTROT", selectedOption);
              trigger("companySettings[0].adjustWTROT");
            }}
            defaultValue={watch("companySettings[0].adjustWTROT")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].adjustOT`}
            type="commonSelect"
            placeholder="Adjust OT"
            className={`form-control ${
              errors?.companySettings?.[0]?.adjustOT ? "is-invalid" : ""
            }`}
            label="Adjust OT"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Adjust OT is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].adjustOT", selectedOption);
              trigger("companySettings[0].adjustOT");
            }}
            defaultValue={watch("companySettings[0].adjustOT")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].adjustWaitingTime`}
            type="commonSelect"
            placeholder="Adjust Waiting Time"
            className={`form-control ${
              errors?.companySettings?.[0]?.adjustWaitingTime
                ? "is-invalid"
                : ""
            }`}
            label="Adjust Waiting Time"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Adjust Waiting Time is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].adjustWaitingTime", selectedOption);
              trigger("companySettings[0].adjustWaitingTime");
            }}
            defaultValue={watch("companySettings[0].adjustWaitingTime")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].loginHistoryAccess`}
            type="commonSelect"
            placeholder="Login History Access"
            className={`form-control ${
              errors?.companySettings?.[0]?.loginHistoryAccess
                ? "is-invalid"
                : ""
            }`}
            label="Login History Access"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Login History Access is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].loginHistoryAccess", selectedOption);
              trigger("companySettings[0].loginHistoryAccess");
            }}
            defaultValue={watch("companySettings[0].loginHistoryAccess")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].isMultipleLogin`}
            type="commonSelect"
            placeholder="Is Multiple Login"
            className={`form-control ${
              errors?.companySettings?.[0]?.isMultipleLogin ? "is-invalid" : ""
            }`}
            label="Is Multiple Login"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Is Multiple Login is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].isMultipleLogin", selectedOption);
              trigger("companySettings[0].isMultipleLogin");
            }}
            defaultValue={watch("companySettings[0].isMultipleLogin")}
          />
        </div>

         <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].isMomEnabled`}
            type="commonSelect"
            placeholder="Is MOM Based Contribution"
            className={`form-control ${
              errors?.companySettings?.[0]?.isMomEnabled ? "is-invalid" : ""
            }`}
            label="Is MOM Based Contribution?"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Is MOM Based Contribution is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].isMomEnabled", selectedOption);
              trigger("companySettings[0].isMomEnabled");
            }}
            defaultValue={watch("companySettings[0].isMomEnabled")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].daysBeforePublicHoliday"
            type="number"
            placeholder="Days Before Public Holiday"
            className={`form-control ${
              errors?.companySettings?.[0]?.daysBeforePublicHoliday
                ? "is-invalid"
                : ""
            }`}
            label="Days Before Public Holiday"
            labelClassName="form-label"
            required={true}
            requiredMessage="Days Before Public Holiday is required"
            info={
              descriptions?.find((item) =>
                item?.description?.includes("Days Before Public Holiday"),
              )?.description || ""
            }
            maxLength={4}
            // onChange={isNumberKey}
          />
        </div>

         <div className="col-md-4 mb-3">
          <Input
            name={`companySettings[0].oTontimesheet`}
            type="commonSelect"
            placeholder="OT On Timesheet"
            className={`form-control ${
              errors?.companySettings?.[0]?.oTontimesheet ? "is-invalid" : ""
            }`}
            label="OT On Timesheet"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="OT On Timesheet is required"
            onChange={(selectedOption) => {
              setValue("companySettings[0].oTontimesheet", selectedOption);
              trigger("companySettings[0].oTontimesheet");
            }}
            defaultValue={watch("companySettings[0].oTontimesheet")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="companySettings[0].locationRadius"
            type="number"
            placeholder="Location Radius"
            className={`form-control ${
              errors?.companySettings?.[0]?.locationRadius ? "is-invalid" : ""
            }`}
            label="Location Radius"
            labelClassName="form-label"
            required={false}
            requiredMessage="Location Radius is required"
            maxLength={9}
            // onChange={isNumberKey}
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <label className="form-label" style={{ position: "absolute" }}>
            Company Logo
          </label>
          <ImageCropper
            base64Value={`data:image/png;base64,${watch("companyLogo")}`}
            setBase64Value={(value) => setValue("companyLogo", value)}
          />
          <div className="invalid-feedback">
            {errors.employeePhotoStr?.message}
          </div>
        </div>
      </div>
    </div>
  );
};

CompanyInfo.propTypes = {
  descriptions: PropTypes.array,
};
export default CompanyInfo;
